import { Phone, MapPin, Mail, Clock, Globe } from "lucide-react";
import { COMPANY } from "@/data/services";
import { LOGO_URL } from "@/lib/api";

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-slate-300 pt-20 pb-10" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-12">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <img src={LOGO_URL} alt="Prowess Services" className="h-14 w-14 object-contain rounded-md bg-white p-1" />
              <div>
                <div className="font-display font-extrabold text-xl text-white">PROWESS SERVICES</div>
                <div className="text-sm text-accent">{COMPANY.tagline}</div>
                <a href={COMPANY.websiteHref} className="text-sm text-slate-400 hover:text-white">{COMPANY.website}</a>
              </div>
            </div>
            <p className="text-slate-400 max-w-md leading-relaxed">
              Your commercial multiservice partner for electrical, plumbing, HVAC, buildouts and
              every trade in between. Licensed, insured and ready to work.
            </p>
          </div>

          <div>
            <h4 className="font-display font-semibold text-white mb-4">Contact</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-center gap-2">
                <Phone className="h-4 w-4 text-accent" />
                <a href={COMPANY.phoneHref} className="hover:text-white">{COMPANY.phoneDisplay}</a>
              </li>
              <li className="flex items-center gap-2 text-slate-400">
                <Phone className="h-4 w-4 text-accent" />{COMPANY.phoneSub}
              </li>
              <li className="flex items-start gap-2 text-slate-400">
                <MapPin className="h-4 w-4 text-accent mt-0.5" />Greater Houston, TX area
              </li>
              <li className="flex items-center gap-2">
                <Mail className="h-4 w-4 text-accent" />
                <a href={COMPANY.emailHref} className="hover:text-white break-all">{COMPANY.email}</a>
              </li>
              <li className="flex items-center gap-2">
                <Globe className="h-4 w-4 text-accent" />
                <a href={COMPANY.websiteHref} className="hover:text-white">{COMPANY.website}</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-display font-semibold text-white mb-4">Hours</h4>
            <ul className="space-y-3 text-sm text-slate-400">
              <li className="flex items-center gap-2"><Clock className="h-4 w-4 text-accent" />Mon–Fri: 7am – 6pm</li>
              <li className="flex items-center gap-2"><Clock className="h-4 w-4 text-accent" />Sat: 8am – 2pm</li>
              <li className="flex items-center gap-2"><Mail className="h-4 w-4 text-accent" />24/7 online booking</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-12 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4 text-sm text-slate-500">
          <p>© {new Date().getFullYear()} Prowess Services. All rights reserved.</p>
          <a href="/admin/login" data-testid="footer-admin-link" className="hover:text-slate-300">Admin Login</a>
        </div>
      </div>
    </footer>
  );
}
